import { Divider } from 'antd';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { memo, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { edit_report_name, right_open_arrow } from '../../assets/img';
import { PERMISSION } from '../../utils/constants';
import CommonLoading from '../CommonLoading/CommonLoading';
import styles from './career-aspiration.module.scss';
import CareerAspirationEdit from './CareerAspirationEdit';
import CareerAspirationModalTable from './CareerAspirationModalTable';
import { TP_PRINT_SECTION_NAME } from '../TalentProfilePrintPreview/constants';

const CareerAspiration = ({ carreerAspiration, isFromTalentReview, isPrinting, getTalentProfileSummary, loading, tokenTalentProfile, id }) => {
  const sid = useParams()?.id || id;
  const user = useSelector((state) => state.user);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const roleUser = { roleActive: user.roleActive, permissions: user.permissions };
  const { desiredCareerPath, aspirationMatching } = carreerAspiration;
  const [openModal, setOpenModal] = useState(false);
  const [aspirationMatchingEdit, setAspirationMatchingEdit] = useState({
    open: false,
    mode: '',
  });

  const editPermission = useMemo(() => {
    return !isEmpty(roleUser?.permissions) && roleUser.permissions.includes(PERMISSION.EDIT_ASPIRATION_MATCHING);
  }, [roleUser]);

  const handleOpenModalView = () => {
    setOpenModal(true);
  };

  return (
    <div className={styles.container} style={!(isPrinting && isFromTalentReview) ? { backgroundColor: '#f4f5f8' } : { backgroundColor: '#ffffff' }}>
      <div data-print-section={TP_PRINT_SECTION_NAME.CAREER_STATEMENT} className={styles.careerStatement} style={{ padding: '28px 12px 30px 16px' }}>
        {!(isPrinting && isFromTalentReview) &&
          <div style={{
            fontFamily: "Inter",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "22px",
            letterSpacing: "0.3px",
            color: "#3d3d3d",
            paddingBottom: '10px',
          }}>Career Statement </div>
        }

        <div>
          {!loading ? (
            !isEmpty(desiredCareerPath) &&
            desiredCareerPath.map((item, index) => (
              <p
                dangerouslySetInnerHTML={{ __html: `${item.career_statement || item.aspiration || ''}` }}
                className={`${styles.item} ${isFromTalentReview ? styles.content : ''}`}
                key={index}
              />
            ))
          ) : (
            <div style={{ width: '785.04px' }} className="d-flex justify-content-center">
              <CommonLoading />
            </div>
          )}
        </div>
      </div>
      {!isFromTalentReview && (
        <div data-print-section={TP_PRINT_SECTION_NAME.ASPIRATION_MATCHING} className={styles.aspiration}>
          <Divider className={styles.divider} />
          <div className={styles.aspirationMatching}>
            <h3>Aspiration Matching</h3>
            <div className={styles.tags}>
              {!loading ? (
                !isEmpty(aspirationMatching) &&
                aspirationMatching.map((tag, index) => (
                  <div key={index} className={styles.item}>
                    {tag}
                  </div>
                ))
              ) : (
                <div style={{ width: '785.04px' }} className="d-flex justify-content-center">
                  <CommonLoading />
                </div>
              )}
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.disclaimer}>NOTES: Data derived from the results of AI Talent Aspiration</div>
            {!isPrinting && (
              <div className={styles.openModal}>
                <div className={styles.view} onKeyDown={() => {}} onClick={handleOpenModalView}>
                  <span>VIEW ASPIRATION</span>
                  <img src={right_open_arrow} alt="open" />
                </div>
                {editPermission && (
                  <img
                    src={edit_report_name}
                    alt="edit"
                    className={styles.edit}
                    onKeyDown={() => {}}
                    onClick={() =>
                      setAspirationMatchingEdit({
                        open: true,
                        mode: 'edit',
                      })
                    }
                    // onClick={() => setOpenModalEdit(true)}
                  />
                )}
              </div>
            )}
          </div>
          {openModal && <CareerAspirationModalTable id={sid} openModal={openModal} setOpenModal={setOpenModal} tokenTalentProfile={tokenTalentProfile} />}
          {aspirationMatchingEdit.open && (
            <CareerAspirationEdit
              aspirationMatchingEdit={aspirationMatchingEdit}
              setAspirationMatchingEdit={setAspirationMatchingEdit}
              roleId={roleUser.roleActive?.roleId}
              permissions={roleUser.permissions}
              staffId={sid}
              getTalentProfileSummary={getTalentProfileSummary}
              tokenTalentProfile={tokenTalentProfile}
            />
          )}
        </div>
      )}
    </div>
  );
};

CareerAspiration.propTypes = {
  isFromTalentReview: PropTypes.bool,
  isPrinting: PropTypes.bool,
  getTalentProfileSummary: PropTypes.func,
  loading: PropTypes.bool,
};

export default memo(CareerAspiration);
